/* Scrolling trust-bar between Hero and Products */
const brands = [
  "Bosch", "Denso", "NGK", "Mahle", "Mann Filter",
  "Brembo", "Gates", "SKF", "Valeo", "Hella",
  "Bosch", "Denso", "NGK", "Mahle", "Mann Filter",
  "Brembo", "Gates", "SKF", "Valeo", "Hella",
];

export default function Marquee() {
  return (
    <div className="bg-gray-50 border-y border-gray-100 py-5 overflow-hidden">
      <div className="flex" style={{ animation: "marquee 28s linear infinite", width: "max-content" }}>
        {brands.map((b, i) => (
          <span key={i} className="flex items-center gap-6 mx-8 text-gray-400 text-sm font-semibold uppercase tracking-widest whitespace-nowrap">
            <svg className="w-1.5 h-1.5 text-red-400 fill-current flex-shrink-0" viewBox="0 0 6 6"><circle cx="3" cy="3" r="3"/></svg>
            {b}
          </span>
        ))}
      </div>
    </div>
  );
}
